export default __webpack_public_path__ + "static/media/logo2Large.e12e3e14.png";